export default __webpack_public_path__ + "static/cards-dont-dark-3d4e782306d62af29c8de9deb2f1173a.png";